// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".labeled-input.view input[data-v-50c2d7a2]{text-overflow:ellipsis}.hideArrows input[data-v-50c2d7a2]::-webkit-inner-spin-button,.hideArrows input[data-v-50c2d7a2]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.hideArrows input[type=number][data-v-50c2d7a2]{-moz-appearance:textfield}", ""]);
// Exports
module.exports = exports;
